<template>
    <div class="seriesRules">
        <div class="container" v-html="serviceRulesHtml" />
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import { ensureGdprCookies } from '@/common/js/gdprCookie';
const htmlTextRecord = import.meta.glob( './ServiceRules/*.html', { query: '?raw', eager: true, import: 'default' });

export default Vue.extend({

    data () {

        return {
            config
        };

    },

    computed: {
        client () {

            return this.config.oem;

        },

        lang(): string {

            return this.$store.getters.lang;

        },
        userStatus () {

            return this.$store.state.user.status;

        },
        serviceRulesHtml(): string {

            let lang = this.lang.toLowerCase();
            if ( lang === 'jp' ) {

                lang = 'ja';
            
            }
            if ( Object.keys( htmlTextRecord ).includes( `./ServiceRules/${ lang }.html` )) {

                return htmlTextRecord[ `./ServiceRules/${ lang }.html` ] as string;

            }

            return htmlTextRecord[ './ServiceRules/en.html' ] as string;

        }
    },
    watch: {

        async userStatus () {

            await ensureGdprCookies( this.$i18n.locale );

        }

    }
});
</script>
<style lang="less" scoped>
.seriesRules{
    background: #f7f8f9;
    padding: .4rem 0;
    /deep/ .container{
        width:9.6rem;
        margin:0 auto;
        background: #fff;
        padding:0;
        padding-bottom: .64rem;
        h1{
            padding:.48rem 0;
            background-color: #5A5A5A;
            margin-bottom:.64rem;
            line-height: 1.4;
            font-size: .36rem;
            text-align: center;
            color:white;
        }
        h2{
            font-size: .24rem;
            line-height: 1.4;
            margin-top: .8rem;
            padding: 0 .5rem;
        }
        h3{
            margin-top: .3rem;
            font-size:.2rem;
            line-height: 1.6;
            padding: 0 .5rem;
        }
        p{
            font-size: .18rem;
            line-height: 2;
            margin-top: .24rem;
            padding: 0 .5rem;
        }
        ol, ul{
            margin-top: .2rem;
            padding-left:.3rem;
            padding: 0 .5rem;
            li{
                margin-top: .16rem;
                font-size: .18rem;
            }
        }

    }
}
@media @mobile {
    .seriesRules{
        background: #f7f8f9;
        padding: 0;
        width: 100%;
        /deep/ .container{
            width:100%;
            background: #fff;
            margin: 0;
            padding: 20px;
            box-sizing: border-box;
            h1{
                padding:.48rem 0;
                background-color: #5A5A5A;
                line-height: 1.4;
                font-size: .50rem;
                text-align: center;
                color:white;
                text-align: center;
                box-sizing: border-box;
                margin: 0;
            }
            h2{
                font-size: .40rem;
                line-height: 1.4;
                margin: 1.08rem 0 0;
                padding: 0;
            }
            h3{
                margin: .64rem 0 0;
                font-size:.34rem;
                line-height: 1.6;
                padding: 0;
            }
            p{
                font-size: .30rem;
                line-height: 2;
                margin: .40rem 0 0;
                padding: 0;
            }
            ul, ol{
                margin: .32rem 0 0;
                padding: 0;
                li{
                    font-size: .30rem;
                }
            }
        }
    }
}
</style>
